const fogCN = {
    FOG_01:'修改成功，3秒后返回登录页',
    FOG_02:'验证邮件已发送，请及时查看',
    FOG_03:'请输入账号',
    FOG_04:'两次输入密码不一致!',
    FOG_05:'请再次输入新密码',
    FOG_06:'请输入新密码',
    FOG_07:'确认',
    FOG_10:'返回登录',
    FOG_11:'发送验证邮件',
}
export default fogCN


// WEBPACK FOOTER //
// ./src/lan/cn/cn_fog.js